/*
 * Buy pill — expanding add-to-cart stepper for product cards.
 * Collapsed "+" adds the product to the cart, then expands into
 * [trash/minus] [qty] [+]. All changes hit the real Shopify Cart AJAX API and
 * update the header cart bubble via the theme's "cart:update" event.
 */
(function () {
  'use strict';
  if (window.__buyPillInit) return; // may be included by several sections on one page
  window.__buyPillInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function url(path) { return ROOT.replace(/\/$/, '') + path; }

  // Only one pill's stepper is expanded at a time; the rest rest as a gold
  // circle showing their quantity (or the black cart circle when empty).
  var allPills = [];
  function collapseOthers(except) {
    allPills.forEach(function (p) { if (p !== except) p.collapse(); });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.buy-pill')) allPills.forEach(function (p) { p.collapse(); });
  });

  function postJSON(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Fire the theme's "cart:update" so the header bubble AND the cart drawer
  // contents refresh — but temporarily strip `auto-open` from the drawer so it
  // doesn't pop open on every add. Event listeners run synchronously, so we can
  // remove the attribute, dispatch, and restore it right after.
  function notifyCart(cart) {
    var drawers = document.querySelectorAll('cart-drawer-component[auto-open]');
    drawers.forEach(function (d) { d.removeAttribute('auto-open'); });
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'buy-pill',
        data: { source: 'buy-pill', itemCount: cart.item_count }
      }
    }));
    drawers.forEach(function (d) { d.setAttribute('auto-open', ''); });
  }

  function Pill(el, qty) {
    this.el = el;
    this.variantId = el.getAttribute('data-variant-id');
    this.qtyEl = el.querySelector('[data-buy-qty]');
    this.addCountEl = el.querySelector('[data-buy-add-count]');
    this.committed = qty || 0; // quantity currently in the cart
    this.target = this.committed; // quantity the UI is showing / aiming for
    this.busy = false;
    this.expanded = false; // is the stepper open (this pill is the active one)?
    var self = this;

    // The circle: open the stepper to edit; if empty, also add the first item.
    var addBtn = el.querySelector('[data-buy-add]');
    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      self.expand();
      if (self.target === 0) self.change(1);
    });
    function bind(sel, delta) {
      var b = el.querySelector(sel);
      if (b) b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        self.expanded = true;
        self.change(delta);
      });
    }
    bind('[data-buy-inc]', 1);
    bind('[data-buy-dec]', -1);
    // Bulk / case button: rounds up to the next full case (4 → 12, 14 → 24).
    var bulkBtn = el.querySelector('[data-buy-bulk]');
    if (bulkBtn) bulkBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      self.expanded = true;
      var bulk = parseInt(bulkBtn.getAttribute('data-bulk'), 10) || 1;
      self.target = (Math.floor(self.target / bulk) + 1) * bulk;
      self.render();
      self.process();
    });
    allPills.push(this);
    this.render();
  }

  Pill.prototype.render = function () {
    this.qtyEl.textContent = this.target;
    if (this.addCountEl) this.addCountEl.textContent = this.target;
    this.el.classList.toggle('has-items', this.target > 0);
    this.el.classList.toggle('is-expanded', this.expanded);
    this.el.classList.toggle('is-one', this.target === 1);
  };

  Pill.prototype.expand = function () {
    collapseOthers(this);
    this.expanded = true;
    this.render();
  };
  Pill.prototype.collapse = function () {
    if (!this.expanded) return;
    this.expanded = false;
    this.render();
  };

  Pill.prototype.change = function (delta) {
    this.target = Math.max(0, this.target + delta);
    // Trash / minus down to 0 → collapse the stepper back to the circle button.
    if (this.target === 0) this.expanded = false;
    this.render(); // optimistic
    this.process();
  };

  Pill.prototype.variantQty = function (cart) {
    if (!cart || !cart.items) return 0;
    var vid = String(this.variantId), q = 0;
    cart.items.forEach(function (it) { if (String(it.id) === vid) q += it.quantity; });
    return q;
  };

  Pill.prototype.process = function () {
    var self = this;
    if (this.busy || this.target === this.committed) return;
    this.busy = true;
    var want = this.target; // snapshot the value we're syncing to
    var req;
    var stockMax = null; // set when the server caps us below `want`
    if (this.committed === 0 && want > 0) {
      // change.js can't create a new line — use add.js, then read the full cart.
      req = postJSON('/cart/add.js', { items: [{ id: Number(this.variantId), quantity: want }] })
        .then(function (res) {
          // add.js returns a 422 error object when `want` exceeds available stock
          // (nothing is added). Read the available count and add that many instead.
          if (res && res.status === 422) {
            var m = String(res.description || res.message || '').match(/(\d+)/);
            stockMax = m ? parseInt(m[1], 10) : 0;
            if (stockMax > 0) {
              return postJSON('/cart/add.js', { items: [{ id: Number(self.variantId), quantity: stockMax }] })
                .then(function () { return getCart(); });
            }
          }
          return getCart();
        });
    } else {
      req = postJSON('/cart/change.js', { id: String(this.variantId), quantity: want });
    }
    req.then(function (cart) {
      self.committed = self.variantQty(cart);
      // Only correct the shown number if the SERVER clamped our request (e.g.
      // out of stock). Extra taps made while busy live in self.target and are
      // flushed by the process() call below — so the number never jumps back.
      if (self.committed !== want) { self.target = self.committed; self.render(); }
      // If we couldn't reach `want`, the item is stock-capped — tell the shopper.
      if (self.committed < want) {
        var avail = (stockMax != null) ? stockMax : self.committed;
        self.showStockLimit(avail);
      }
      notifyCart(cart);
    }).catch(function () {
      self.target = self.committed; self.render();
    }).then(function () {
      self.busy = false;
      self.process(); // flush any taps queued while busy (one more request, to latest target)
    });
  };

  // Small transient "only N in stock" message over the card image, shown when a
  // tap pushes the quantity past what's available.
  Pill.prototype.showStockLimit = function (n) {
    var item = this.el.closest('.pl-buypill');
    var host = (item && item.querySelector('.card-gallery, .resource-card__media')) || item || this.el.parentNode;
    if (!host) return;
    try { if (getComputedStyle(host).position === 'static') host.style.position = 'relative'; } catch (e) {}
    var toast = host.querySelector('.buy-pill-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'buy-pill-toast';
      host.appendChild(toast);
    }
    var en = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('en') === 0;
    if (n > 0) {
      toast.textContent = en ? ('Only ' + n + ' left in stock') : ('Aðeins ' + n + ' til á lager');
    } else {
      toast.textContent = en ? 'Out of stock' : 'Uppselt';
    }
    toast.classList.remove('is-visible');
    void toast.offsetWidth; // restart the fade/slide transition
    toast.classList.add('is-visible');
    clearTimeout(this.__toastT);
    this.__toastT = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  };

  // Position every pill over the bottom of its product image. We batch ALL layout
  // READS, then ALL WRITES, so N pills cost a single layout flush instead of N forced
  // synchronous layouts (that read/write interleave stalled the main thread on slow
  // Android). The pill stays a child of the grid item so a card re-render can't remove it.
  function positionAll() {
    var pills = document.querySelectorAll('[data-buy-pill]');
    if (!pills.length) return;
    var wide = window.matchMedia('(min-width: 750px)').matches;
    var writes = [];
    pills.forEach(function (el) {
      var item = el.closest('.pl-buypill');
      if (!item) return;
      var gallery = item.querySelector('.card-gallery, .resource-card__media');
      // Resource cards (search / recommendations): anchor the pill INSIDE the image
      // wrapper so it always sits on the photo regardless of text height / timing.
      if (gallery && gallery.classList.contains('resource-card__media')) {
        if (el.parentNode !== gallery) {
          gallery.style.position = 'relative';
          gallery.appendChild(el);
          el.style.bottom = '';
        }
        return;
      }
      if (item.hidden || item.offsetParent === null) return; // can't measure a hidden card
      if (!gallery) { el.style.bottom = ''; return; } // CSS fallback (item bottom)
      // READ phase — no style writes here, so these resolve from one layout.
      var itemRect = item.getBoundingClientRect();
      var galRect = gallery.getBoundingClientRect();
      var bottom = Math.max(0, item.offsetHeight - (galRect.bottom - itemRect.top) + (wide ? 12 : 10));
      writes.push({ el: el, bottom: bottom, qa: item.querySelector('quick-add-component') });
    });
    // WRITE phase — apply every style change together, after all the reads.
    writes.forEach(function (w) {
      w.el.style.bottom = w.bottom + 'px';
      if (w.qa) w.qa.style.display = 'none';
    });
  }

  function init() {
    var pills = document.querySelectorAll('[data-buy-pill]');
    if (!pills.length) return;
    // Bind the "+" / stepper handlers SYNCHRONOUSLY (no layout work) so a card is
    // buyable the instant it's parsed — never gate interactivity on a round-trip. Each
    // pill starts optimistically at 0; resyncFromCart() reconciles the real counts from
    // /cart.js (it skips pills mid-interaction, and add.js re-reads the full cart, so an
    // item already in the cart self-corrects without a double-add).
    pills.forEach(function (el) {
      if (!el.__pill) el.__pill = new Pill(el, 0);
    });
    positionAll();
    resyncFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', positionAll);
  window.addEventListener('resize', function () {
    clearTimeout(window.__buyPillResize);
    window.__buyPillResize = setTimeout(positionAll, 150);
  });
  document.addEventListener('shopify:section:load', init);
  // Re-measure after a filter/sort reveals or reorders cards (see product-list-filters.js).
  document.addEventListener('pl:rendered', function () {
    requestAnimationFrame(positionAll);
  });

  // Keep pill counts in sync when the cart changes elsewhere (item removed in the
  // side drawer, another pill, another tab…) so they never show a stale number.
  function applyCartToPills(cart) {
    var pills = document.querySelectorAll('[data-buy-pill]');
    if (!pills.length) return;
    var map = {};
    (cart.items || []).forEach(function (it) { map[String(it.id)] = (map[String(it.id)] || 0) + it.quantity; });
    pills.forEach(function (el) {
      var p = el.__pill;
      if (!p || p.busy || p.target !== p.committed) return; // skip in-flight changes
      var qty = map[el.getAttribute('data-variant-id')] || 0;
      if (qty === p.committed) return; // already correct
      p.committed = qty;
      p.target = qty;
      if (qty === 0) p.expanded = false; // collapse back to the circle
      p.render();
    });
  }
  function resyncFromCart() {
    if (!document.querySelector('[data-buy-pill]')) return;
    getCart().then(applyCartToPills);
  }
  // On cart:update, reuse the cart the event already carries (detail.resource) instead
  // of firing another /cart.js — several scripts listen to this event and each used to
  // refetch the same cart. Fall back to a fetch only when no cart is attached.
  document.addEventListener('cart:update', function (e) {
    var cart = e && e.detail && e.detail.resource;
    if (cart && cart.items) applyCartToPills(cart);
    else resyncFromCart();
  });

  // Init pills that get injected after load (e.g. async "you might also like").
  if (window.MutationObserver) {
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      var found = false;
      for (var i = 0; i < muts.length && !found; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('[data-buy-pill]')) || (n.querySelector && n.querySelector('[data-buy-pill]')))) { found = true; break; }
        }
      }
      if (found && !pending) {
        pending = true;
        requestAnimationFrame(function () { pending = false; init(); requestAnimationFrame(positionAll); });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
